import { Component, inject } from '@angular/core';
import { ToastType } from '../../enums/toast.types';
import { Toast } from '../../models/toast.model';
import { ToastService } from '../../services/toasts/toast.service';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-toast',
  imports: [IconComponent],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  public toastService = inject(ToastService);
  protected readonly ToastType = ToastType;

  close(toast: Toast): void {
    this.toastService.remove(toast);
  }
}
